import React from 'react';
import { styled } from '@linaria/react';
import { OfferPrice } from 'components/Offer/Shared/OfferPrice';
import { Box } from '@daedalus/atlas/helpers/Box';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { SearchOffer } from '@daedalus/core/src/offer/types/SearchOffer';
import { Taxation } from './Taxation';
const FromMessage = /*#__PURE__*/styled('div')({
  name: "FromMessage",
  class: "fq4dije",
  propsAsIs: false
});
interface Props {
  hotelId: string;
  includeLocalTaxes: boolean;
  includeTaxes: boolean;
  isSplitBooking?: boolean;
  noSpecialStyle?: boolean;
  offer?: SearchOffer;
  showTotalPrices: boolean;
  isPrivateDeal?: boolean;
}
export const Price: React.FC<Props> = ({
  hotelId,
  includeLocalTaxes,
  includeTaxes,
  isSplitBooking,
  noSpecialStyle = false,
  offer,
  showTotalPrices,
  isPrivateDeal = false
}) => {
  return <Box marginTop="s200" marginBottom="s300" marginRight="s100" flexDirection="column" display="flex" alignItems="flex-end">
      <Box display="flex" alignItems="flex-end">
        <FromMessage>
          <FormattedMessageWrapper id="from" defaultMessage="from" />
        </FromMessage>
        <OfferPrice hotelId={hotelId} isSplitBooking={isSplitBooking} noSpecialStyle={noSpecialStyle} offer={offer} size="xl" isPrivateDeal={isPrivateDeal} />
      </Box>

      <Taxation includeLocalTaxes={includeLocalTaxes} includeTaxes={includeTaxes} showTotalPrices={showTotalPrices} />
    </Box>;
};

require("./Price.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Price.tsx");